const ActiveCountries  = ['IN']

export default ActiveCountries;